import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '@blaze-shared/shared-feature';

import { IntelliContextEffects } from './+state/intelli-context.effects';
import { INTELLISENSE_FEATURE_KEY, reducer } from './+state/intellisense.reducer';
import { IntelliSenseService } from './intellisense.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(INTELLISENSE_FEATURE_KEY, reducer),
    EffectsModule.forFeature([IntelliContextEffects]),
  ],
  providers: [IntelliSenseService],
})
export class IntellisenseCoreModule {}
